import script from "./PostbackSetupGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./PostbackSetupGuide.vue?vue&type=script&setup=true&lang=js"

import "./PostbackSetupGuide.vue?vue&type=style&index=0&id=0b4f4f1f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b4f4f1f"]])

export default __exports__